import { Field } from "../../field";
import { BusinessOwner } from "../../fieldsets";
import { Merchant } from "../../merchant";
import { CountryList, MerchantField, VerificationMethod } from "../../types";

type CountryListVerificationMethodMap = {
  [key in CountryList]?: VerificationMethod[];
};
export const countryListVerificationMethodMap: CountryListVerificationMethodMap = {
  "New Zealand": [
    "Certified Passport",
    "Licence Birth Certificate",
    "Licence Document",
  ],
};

const defaultValue: VerificationMethod = "Certified Passport";

export class VerificationMethodField extends Field<VerificationMethod> {
  private readonly _owner: BusinessOwner;

  constructor(
    model: Merchant,
    owner: BusinessOwner,
    opts: Partial<MerchantField<VerificationMethod>> = {}
  ) {
    super(model, {
      dataType: "string",
      testValue: defaultValue,
      propertyName: "verificationMethod",
      uiFieldType: "Select",
      value: defaultValue,
      ...opts,
    });

    this._owner = owner;
  }

  get pickList(): VerificationMethod[] {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;

    return registeredCountry
      ? countryListVerificationMethodMap[registeredCountry] ?? []
      : [];
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;

    const { requireCertifiedId } = this._owner.controlValues;

    return registeredCountry === "New Zealand" && requireCertifiedId;
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }
}
